import { Cache } from "memory-cache";
import { CorporationOrderHistoryEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCorporationOrderHistoryEntity(
  order_id: number
): Promise<CorporationOrderHistoryEntity | null> {
  let entity: any = await cache.get(order_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationOrderHistoryEntity(order: CorporationOrderHistoryEntity) {
  cache.put(order.props.order_id.toString(), order, 60 * 60 * 1000 /* 1 hour */);
}
